import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import Select from "react-select";
import {
  Box,
  Flex,
  Heading,
  HStack,
  VStack,
  SimpleGrid,
  Text,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  InputRightElement,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Badge,
  Center,
  Button,
  Spinner,
} from "@chakra-ui/react";
import API_CONFIG from "../../Configuration/apiConfig";
import apiClient from "../../Configuration/apiClient";
import styles from "components/Styles/AsmStyles.js";
import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import "components/Styles/MsdStyles.css";
import {
  SearchIcon,
  CloseIcon,
  ViewIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import ViewDetails from "views/AsmReport/viewDetails";
import AgGridWrapper from "components/AgGrid/AgGridWrapper";

const ActionCellRenderer = (props) => {
    return (
      <Button
        size="sm"
        colorScheme="red"
        variant="outline"
        leftIcon={<ViewIcon />}
        onClick={() => {
        if (props.context?.handleSOAction && props.data) {
          props.context.handleSOAction(props.data); 
        }
      }}

        _hover={{ bg: "red.50" }}
      >
        View
      </Button>
    );
  };


function MsdDp({ fromDate, toDate }) {
  const [regionList, setRegionList] = useState([]);
  const [subRegionList, setSubRegionList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedSubRegions, setSelectedSubRegions] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [loadingSubRegion, setLoadingSubRegion] = useState(false);
  const [loadingCity, setLoadingCity] = useState(false);
  const [loadingChannel, setLoadingChannel] = useState(false);
  const [loadingType, setLoadingType] = useState(false);
  const [distributorManagerNames, setDistributorManagerNames] = useState([]);
  const [error, setError] = useState("");
  const [loadingDMN, setLoadingDMN] = useState(false);
  const [totalOutlets, setTotalOutlets] = useState(0);
  const [redScore, setRedScore] = useState(0);
  const [availabilityScore, setAvailabilityScore] = useState(0);
  const [activationScore, setActivationScore] = useState(0);
  const [coolerScore, setCoolerScore] = useState(0);
  const [bonusScore, setBonusScore] = useState(0);
  const [loadingScores, setLoadingScores] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [salesOfficersDist, setSalesOfficersDist] = useState([]);
  const [distributorDetails, setDistributorDetails] = useState(null);
  const [loadingSODist, setLoadingSODist] = useState(false);
  const [isOpenDist, setIsOpenDist] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDistributors, setFilteredDistributors] = useState([]);
  const [distCurrentPage, setDistCurrentPage] = useState(1);
  const [distPageSize, setDistPageSize] = useState(10);

  // New state for AG Grid pagination
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridPageSize, setGridPageSize] = useState(5);
  const gridApiRef = useRef(null);

  const prevFiltersRef = useRef({})
  const isInitialMount = useRef(true);
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const [selectedSo, setSelectedSo] = useState(null);
  const [showViewDetails, setShowViewDetails] = useState(false);
 

  const getMonthRangeBody = () => {
    const [fromYear, fromMonthNum, fromDay] = fromDate.split('-').map(Number);
    const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);
    return {
      from: {
        date: fromDay,
        month: fromMonthNum,
        year: fromYear,
      },
      to: {
        date: toDay,
        month: toMonthNum,
        year: toYear
      }

    };

  };


  useEffect(() => {
    if (isOpenDist) {
      setGridCurrentPage(1);
    }
  }, [isOpenDist]);


  const handleGridPreviousPage = () => {
    if (gridCurrentPage > 1) {
      setGridCurrentPage(gridCurrentPage - 1);
      if (gridApiRef.current) {
        gridApiRef.current.paginationGoToPreviousPage();
      }
    }
  };

  const handleGridNextPage = () => {
    const totalPages = Math.ceil(salesOfficersDist.length / gridPageSize);
    if (gridCurrentPage < totalPages) {
      setGridCurrentPage(gridCurrentPage + 1);
      if (gridApiRef.current) {
        gridApiRef.current.paginationGoToNextPage();
      }
    }
  };

  const handleGridPageChange = (page) => {
    setGridCurrentPage(page);
    if (gridApiRef.current) {
      gridApiRef.current.paginationGoToPage(page - 1);
    }
  };

  useEffect(() => {
    setFilteredDistributors(distributorManagerNames);
  }, [distributorManagerNames]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredDistributors(distributorManagerNames);
    } else {
      const filtered = distributorManagerNames.filter((distributor) =>
        distributor.ManagerName.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredDistributors(filtered);
    }
  };


  // Helper function to create filter string for comparison
  const getFilterString = useCallback(() => {
    return JSON.stringify({
      fromDate, toDate,
      regions: selectedRegions.map(r => r.value).sort().join(','),
      subRegions: selectedSubRegions.map(sr => sr.value).sort().join(','),
      cities: selectedCities.map(c => c.value).sort().join(','),
      channels: selectedChannels.map(ch => ch.value).sort().join(','),
      types: selectedTypes.map(t => t.value).sort().join(',')
    })
  }, [fromDate, toDate, selectedRegions, selectedSubRegions, selectedCities, selectedChannels, selectedTypes])


  // Convert lists to react-select format - MEMOIZED
  const regionOptions = useMemo(() => regionList.map(item => ({ value: item, label: item })), [regionList]);
  const subRegionOptions = useMemo(() => subRegionList.map(item => ({ value: item, label: item })), [subRegionList])
  const cityOptions = useMemo(() => cityList.map(item => ({ value: item, label: item })), [cityList])
  const channelOptions = useMemo(() => channelList.map(item => ({ value: item, label: item })), [channelList])
  const typeOptions = useMemo(() => typeList.map(item => ({ value: item, label: item })), [typeList])

  const handleSOAction = (data) => {
    setSelectedSo(data);
    setShowViewDetails(true);

  };

  
  const cards = [
    { label: "  Average Total RedScore", value: redScore, variant: "score-card--red" },
    {
      label: "Average Availability",
      value: availabilityScore,
      variant: "score-card--green",
    },
    { label: "Average Activation", value: activationScore, variant: "score-card-red" },
    { label: "Average Cooler", value: coolerScore, variant: "score-card--peach" },
    { label: "Average Cooler Bonus", value: bonusScore, variant: "score-card--blue" },
  ];
  const colors = ["red.500", "green.500", "yellow.500", "red.500", "blue.500"];


  useEffect(() => {
    const currentFilterString = getFilterString()
    if (prevFiltersRef.current.scores === currentFilterString && !isInitialMount.current) {
      return
    }
    prevFiltersRef.current.scores = currentFilterString
    const fetchScores = async () => {
      if (!fromDate || !toDate) {
        setRedScore(0);
        setAvailabilityScore(0);
        setActivationScore(0);
        setCoolerScore(0);
        setBonusScore(0);
        setTotalOutlets(0);
        return;
      }

      setLoadingScores(true);

      try {
        let filters = {};
        if (selectedRegions.length > 0) {
          filters = {
            dropdown1: selectedRegions.map(r => r.value).join(', '),
            dropdown2: selectedSubRegions.map(sr => sr.value).join(', '),
            dropdown3: selectedCities.map(c => c.value).join(', '),
            dropdown4: selectedChannels.map(ch => ch.value).join(', '),
            dropdown5: selectedTypes.map(t => t.value).join(', ')
          };
        }

        const [fromYear, fromMonthNum, fromDay] = fromDate.split("-").map(Number);
        const [toYear, toMonthNum, toDay] = toDate.split("-").map(Number);

        const requestBody = {
          filters: filters,
          timePeriod: {
            from: {
              date: fromDay,
              month: fromMonthNum,
              year: fromYear
            },
            to: {
              date: toDay,
              month: toMonthNum,
              year: toYear
            }
          }
        };


        const res = await apiClient.post(
          `${API_CONFIG.ENDPOINTS.ASM_REPORT.SCORES}`,
          requestBody
        );

        setRedScore(res.data.totalRedScore || 0);
        setAvailabilityScore(res.data.availabilityScore || 0);
        setActivationScore(res.data.activationScore || 0);
        setCoolerScore(res.data.coolerScore || 0);
        setBonusScore(res.data.coolerBonus || 0);
        setTotalOutlets(res.data.totalOutlets || 0);
      } catch (err) {
        console.error("Failed to load scores:", err);
        setError("Failed to load scores data.");
        setRedScore(0);
        setAvailabilityScore(0);
        setActivationScore(0);
        setCoolerScore(0);
        setBonusScore(0);
        setTotalOutlets(0);
      } finally {
        setLoadingScores(false);
      }
    };

    fetchScores();
  }, [selectedRegions, selectedSubRegions, selectedCities, selectedChannels, selectedTypes, fromDate, toDate, getFilterString]);

  const salesOfficerColumns = useMemo(() => [
  {
    headerName: "SO Name",
    field: "soName",
    flex: 2,
    minWidth: 120,
    filter: "agTextColumnFilter",
    tooltipField: "soName",
  },
  { headerName: "Shops",      field: "totalShops",        flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  { headerName: "Red Score",  field: "totalRedScore",     flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  { headerName: "Avail.",     field: "availabilityScore", flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  { headerName: "Activation", field: "activationScore",   flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  { headerName: "Cooler",     field: "coolerScore",       flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  { headerName: "C.Bonus",    field: "coolerBonus",       flex: 1, minWidth: 65, filter: "agNumberColumnFilter" },
  {
    headerName: "Action",
    colId: "actions",
    field: "",
    valueGetter: () => null,
    width: 90, minWidth: 90, maxWidth: 90,
    filter: false,
    sortable: false,
    cellRenderer: ActionCellRenderer,
  },
], []);

  const totalGridPages = Math.ceil(salesOfficersDist.length / gridPageSize);
  const gridStartIndex = (gridCurrentPage - 1) * gridPageSize + 1;
  const gridEndIndex = Math.min(gridCurrentPage * gridPageSize, salesOfficersDist.length);

  // 1. Fetch Regions when MONTH changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (!fromDate || !toDate) return;
      setSubRegionList([]);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      try {
        const requestBody = getMonthRangeBody();
        const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");

        const res = await apiClient.request({
          method: 'POST',
          url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.REGIONDP}`,
          data: requestBody,
          params: { userId },

        })

        setRegionList(Array.isArray(res.data) ? res.data : [res.data]);

        setSelectedRegions([]);
        setSubRegionList([]);
        setSelectedSubRegions([]);
        setCityList([]);
        setSelectedCities([]);
        setChannelList([]);
        setSelectedChannels([]);
        setTypeList([]);
        setSelectedTypes([]);
        setSelectedDistributor(null);
        setSalesOfficersDist([]);
        setDistributorDetails(null);
        setIsOpenDist(false);
      } catch (err) {
        console.error("Failed to load regions:", err);
        setError("Failed to load region dropdown data.");
      }
    };
    fetchRegions();
  }, [fromDate, toDate]);

  // 2. FIXED: Fetch SubRegions when REGIONS changes (multi regions)
  useEffect(() => {
    if (selectedRegions.length === 0) {
      setSubRegionList([]);
      setSelectedSubRegions([]);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      setSelectedDistributor(null);
      setSalesOfficersDist([]);
      setDistributorDetails(null);
      setIsOpenDist(false);
      return;
    }

    const fetchSubRegion = async () => {
      if (!fromDate || !toDate) return;

      setLoadingSubRegion(true);
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedRegions.map((region) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.SUBREGIONDP}?regions=${encodeURIComponent(region.value)}`,
            data: requestBody,
          })
        );

        const results = await Promise.all(promises);
        const allSubRegions = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueSubRegions = [...new Set(allSubRegions)];
        setSubRegionList(uniqueSubRegions);
        setSelectedSubRegions([]);
      } catch (err) {
        console.error("Failed to load subRegions:", err);
        setError("Failed to load subregion dropdown data.");
        setSubRegionList([]);
      } finally {
        setLoadingSubRegion(false);
      }
    };
    fetchSubRegion();
  }, [selectedRegions, fromDate, toDate]);

  // 3. Fetch Cities when SUBREGIONS change
  useEffect(() => {
    if (selectedSubRegions.length === 0) {
      setCityList([]);
      setSelectedCities([]);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchCity = async () => {
      if (!fromDate || !toDate) return;

      setLoadingCity(true);
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedSubRegions.map((subRegion) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.CITYDP}?subRegions=${encodeURIComponent(subRegion.value)}`,
            data: requestBody,
          })
        );


        const results = await Promise.all(promises);
        const allCities = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueCities = [...new Set(allCities)];
        setCityList(uniqueCities);
        setSelectedCities([]);
      } catch (err) {
        console.error("Failed to load cities:", err);
        setError("Failed to load city dropdown data.");
        setCityList([]);
      } finally {
        setLoadingCity(false);
      }
    };
    fetchCity();
  }, [selectedSubRegions, fromDate, toDate]);

  // 4. Fetch Channels when CITIES change
  useEffect(() => {
    if (selectedCities.length === 0) {
      setChannelList([]);
      setSelectedChannels([]);
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchChannel = async () => {
      if (!fromDate || !toDate) return

      setLoadingChannel(true);
      setTypeList([]);
      setSelectedTypes([]);

      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedCities.map((city) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.CHANNELDP}?cities=${encodeURIComponent(city.value)}`,
            data: requestBody,
          })
        );


        const results = await Promise.all(promises);
        const allChannels = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueChannels = [...new Set(allChannels)];
        setChannelList(uniqueChannels);
        setSelectedChannels([]);
      } catch (err) {
        console.error("Failed to load channels:", err);
        setError("Failed to load channel dropdown data.");
        setChannelList([]);
      } finally {
        setLoadingChannel(false);
      }
    };
    fetchChannel();
  }, [selectedCities, fromDate, toDate]);

  // 5. Fetch Types when CHANNELS change
  useEffect(() => {
    if (selectedChannels.length === 0) {
      setTypeList([]);
      setSelectedTypes([]);
      return;
    }

    const fetchType = async () => {
      if (!fromDate || !toDate) return;

      setLoadingType(true);
      try {
        const requestBody = getMonthRangeBody();
        const promises = selectedChannels.map((channel) =>
          apiClient.request({
            method: 'POST',
            url: `${API_CONFIG.ENDPOINTS.ASM_REPORT.TYPEDP}?channels=${encodeURIComponent(channel.value)}`,
            data: requestBody,
          })
        );
        const results = await Promise.all(promises);
        const allTypes = results.flatMap((res) =>
          Array.isArray(res.data) ? res.data : [res.data]
        );
        const uniqueTypes = [...new Set(allTypes)];
        setTypeList(uniqueTypes);
        setSelectedTypes([]);
      } catch (err) {
        console.error("Failed to load types:", err);
        setError("Failed to load type dropdown data.");
        setTypeList([]);
      } finally {
        setLoadingType(false);
      }
    };
    fetchType();
  }, [selectedChannels, fromDate, toDate]);


  useEffect(() => {
    const currentFilterString = getFilterString()
    if (prevFiltersRef.current.asmNames === currentFilterString && !isInitialMount.current) {

      return
    }
    prevFiltersRef.current.asmNames = currentFilterString
    isInitialMount.current = false

    const fetchDistributorNames = async () => {
      setDistributorManagerNames([]);
      setError(null);
      const requestBody = {
        filters: {},
        timePeriod: getMonthRangeBody(),
        userId: localStorage.getItem("userId") || sessionStorage.getItem("userId"),
      };
      if (selectedRegions.length > 0) {
        requestBody.filters.dropdown1 = selectedRegions.map(r => r.value).join(', ');
        if (selectedSubRegions.length > 0) {
          requestBody.filters.dropdown2 = selectedSubRegions.map(item => item.value).join(', ');
        }
        if (selectedCities.length > 0) {
          requestBody.filters.dropdown3 = selectedCities.map(c => c.value).join(', ');
        }
        if (selectedChannels.length > 0) {
          requestBody.filters.dropdown4 = selectedChannels.map(ch => ch.value).join(', ');
        }
        if (selectedTypes.length > 0) {
          requestBody.filters.dropdown5 = selectedTypes.map(t => t.value).join(', ');
        }
      }
      if (!fromDate || !toDate) return;
      setLoadingDMN(true);
      try {
        const res = await apiClient.post(
          `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ASM_REPORT.ASM}?roleType=DISTRIBUTOR`,
          requestBody
        );

        const data = (Array.isArray(res.data) ? res.data : [res.data]).map(name => ({
          ManagerName: typeof name === "string" ? name : name.ManagerName || name.name || name,
        }));


        setDistributorManagerNames(data);

        if (data.length === 0) {
          setError("No distributors found.");
        }

      } catch (err) {
        console.error("Failed to fetch distributor names:", err);
        setError("Failed to fetch distributor names. Please try again.");
        setDistributorManagerNames([]);
      } finally {
        setLoadingDMN(false);
      }
    };

    fetchDistributorNames();

  }, [fromDate, toDate, selectedRegions, selectedSubRegions, selectedCities, selectedChannels, selectedTypes, getFilterString]);


  // Fetch sales officers details when Distributor is selected
  useEffect(() => {
    const fetchSODetails = async () => {
      if (!selectedDistributor || !fromDate || !toDate) {
        setSalesOfficersDist([]);
        setDistributorDetails(null);
        return;
      }

      setLoadingSODist(true);

      try {
        // Build request body in the new format expected by the endpoint
        const requestBody = {
          filters: {},
          timePeriod: getMonthRangeBody(),
        };

        // Populate filter dropdowns when available
        if (selectedRegions.length > 0) {
          requestBody.filters.dropdown1 = selectedRegions
            .map((r) => r.value)
            .join(", ");
        }

        if (selectedSubRegions.length > 0) {
          requestBody.filters.dropdown2 = selectedSubRegions
            .map((sr) => sr.value)
            .join(", ");
        }

        if (selectedCities.length > 0) {
          requestBody.filters.dropdown3 = selectedCities
            .map((c) => c.value)
            .join(", ");
        }

        if (selectedChannels.length > 0) {
          requestBody.filters.dropdown4 = selectedChannels
            .map((ch) => ch.value)
            .join(", ");
        }

        if (selectedTypes.length > 0) {
          requestBody.filters.dropdown5 = selectedTypes
            .map((t) => t.value)
            .join(", ");
        }

        const url = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ASM_REPORT.DISTRIBUTOR}?distributorName=${encodeURIComponent(
          selectedDistributor
        )}`;
        const res = await apiClient.post(url, requestBody);
        setDistributorDetails(res.data);
        setSalesOfficersDist(res.data.salesOfficers || []);
      } catch (err) {
        console.error("Failed to fetch sales officers:", err);
        setSalesOfficersDist([]);
        setDistributorDetails(null);
      } finally {
        setLoadingSODist(false);
      }
    };

    fetchSODetails();
  }, [
    selectedDistributor,
    fromDate,
    toDate,
    selectedRegions,
    selectedSubRegions,
    selectedCities,
    selectedChannels,
    selectedTypes,
  ]);
  return (
    <Box>
      <Container maxW="container.2xl" p="0" m="0">
        {/* Filter Section */}
        <Box mt="4">
          <HStack
            spacing={{ base: 3, md: 5 }}
            align="flex-start"
            flexDir={{ base: "column", md: "row" }}
          >
            {/* Region Select */}
            <Box
              flex="1"
              width={{ base: "100%", md: "auto" }}
              mb={{ base: 3, md: 0 }}
              borderRadius="8px"
            >
              <Select
                isMulti
                options={regionOptions}
                value={selectedRegions}
                onChange={setSelectedRegions}
                placeholder="Company Code"
                closeMenuOnSelect={false}
                isClearable
                styles={styles.customSelectStyles}
              />
            </Box>

            {/* Subregions Select */}
            <Box
              flex="1"
              width={{ base: "100%", md: "auto" }}
              mb={{ base: 3, md: 0 }}
            >
              <Select
                isMulti
                options={subRegionOptions}
                value={selectedSubRegions}
                onChange={setSelectedSubRegions}
                placeholder="Subregions"
                closeMenuOnSelect={false}
                isLoading={loadingSubRegion}
                isDisabled={selectedRegions.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>

            {/* Cities Select */}
            <Box
              flex="1"
              width={{ base: "100%", md: "auto" }}
              mb={{ base: 3, md: 0 }}
            >
              <Select
                isMulti
                options={cityOptions}
                value={selectedCities}
                onChange={setSelectedCities}
                placeholder="Cities"
                closeMenuOnSelect={false}
                isLoading={loadingCity}
                isDisabled={selectedSubRegions.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>

            {/* Channels Select */}
            <Box
              flex="1"
              width={{ base: "100%", md: "auto" }}
              mb={{ base: 3, md: 0 }}
            >
              <Select
                isMulti
                options={channelOptions}
                value={selectedChannels}
                onChange={setSelectedChannels}
                placeholder="Channels"
                closeMenuOnSelect={false}
                isLoading={loadingChannel}
                isDisabled={selectedCities.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>

            {/* Type Select */}
            <Box
              flex="1"
              width={{ base: "100%", md: "auto" }}
              mb={{ base: 3, md: 0 }}
            >
              <Select
                isMulti
                options={typeOptions}
                value={selectedTypes}
                onChange={setSelectedTypes}
                placeholder="Type"
                closeMenuOnSelect={false}
                isLoading={loadingType}
                isDisabled={selectedChannels.length === 0}
                styles={styles.customSelectStyles}
              />
            </Box>

            {/* Total Outlets Box */}
            <Box
              bg="gray.800"
              color="white"
              px="4"
              py="3"
              borderRadius="lg"
              minW="150px"
              textAlign="center"
              fontWeight="bold"
              boxShadow="sm"
              width={{ base: "100%", md: "auto" }}
            >
              <Text fontSize="sm" opacity={0.9}>
                Total Outlets
              </Text>
              <Text fontSize="2xl" fontWeight="bold">
                {totalOutlets}
              </Text>
            </Box>
          </HStack>

          {/* Score Cards Section */}
          <Flex mt={6} gap={4} flexWrap="wrap">
            {cards.map((card, index) => (
              <Box
                key={card.label}
                bg="white"
                color="gray.800"
                p={4}
                borderRadius="xl"
                textAlign="center"
                borderBottomWidth="6px"
                borderBottomColor="gray.800"
                boxShadow="md"
                _hover={{
                  boxShadow: "md",
                  transform: "translateY(-2px)",
                }}
                transition="all 0.2s"
                flex="1"
                minW={{ base: "100%", sm: "45%", md: "auto" }}
              >
                <Text fontSize="md" fontWeight="medium" color="gray.800">
                  {card.label}
                </Text>
                {loadingScores ? (
                  <Center h="40px">
                    <Spinner size="sm" color={colors[index % colors.length]} />
                  </Center>
                ) : (
                  <Text
                    fontWeight="bold"
                    fontSize="xl"
                    color={colors[index % colors.length]}
                  >
                    {`${card.value}`}
                  </Text>
                )}
              </Box>
            ))}
          </Flex>
        </Box>

        {/* Distributor Cards Section (Replacing AG Grid) */}
        <Box
          mt="10"
          bg="white"
          borderRadius="xl"
          overflow="hidden"
          boxShadow="sm"
        >
          {/* Search Bar Header */}
          <Flex
            justify="space-between"
            align="center"
            p={4}
            borderBottom="1px solid"
            borderColor="gray.200"
          >
            <InputGroup maxW="400px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Search distributors..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                bg="white"
                borderColor="gray.300"
                focusBorderColor="red.500"
                _placeholder={{ color: "gray.400" }}
              />
              {searchQuery && (
                <InputRightElement>
                  <IconButton
                    aria-label="Clear search"
                    size="sm"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setSearchQuery("");
                      setFilteredDistributors(distributorManagerNames);
                    }}
                    variant="ghost"
                  />
                </InputRightElement>
              )}
            </InputGroup>

            <Text fontSize="sm" color="gray.600" mr={4}>
              {filteredDistributors.length} distributors found
            </Text>
          </Flex>

          {/* Distributors Content */}
          <Box p={4}>
            {!fromDate || !toDate ? (
              <Center h="400px" bg="gray.50" borderRadius="lg">
                <Text color="gray.600">
                  Select a month to load distributors
                </Text>
              </Center>
            ) : loadingDMN ? (
              <Center h="400px" bg="gray.50" borderRadius="lg">
                <VStack spacing={3}>
                  <Spinner size="xl" color="red.600" thickness="4px" />
                  <Text color="gray.600">Loading distributors...</Text>
                </VStack>
              </Center>
            ) : filteredDistributors.length === 0 ? (
              <Center h="400px" bg="gray.50" borderRadius="lg">
                <Text color="gray.600">
                  {searchQuery
                    ? `No distributors found matching "${searchQuery}"`
                    : "No distributors found."}
                </Text>
              </Center>
            ) : (
              <Box>
                {/* Table Container */}
                <Box
                  maxH="400px"
                  overflowY="auto"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="lg"
                >
                  <Table variant="simple" size="md">
                    <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
                      <Tr>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="60%"
                        >
                          Distributor Name
                        </Th>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="20%"
                        ></Th>
                        <Th
                          fontWeight="bold"
                          color="gray.700"
                          borderColor="gray.200"
                          width="20%"
                        >
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {filteredDistributors
                        .slice(
                          (distCurrentPage - 1) * distPageSize,
                          distCurrentPage * distPageSize
                        )
                        .map((distributor, index) => (
                          <Tr
                            key={distributor.ManagerName || index}
                            _hover={{ bg: "red.50" }}
                            transition="background 0.2s"
                          >
                            <Td borderColor="gray.200">
                              <Flex align="center">
                                <Avatar
                                  size="sm"
                                  name={distributor.ManagerName}
                                  mr={3}
                                  bg="red.500"
                                  color="white"
                                />
                                <Box>
                                  <Text fontWeight="medium" color="gray.800">
                                    {distributor.ManagerName}
                                  </Text>
                                  <Text fontSize="xs" color="gray.500">
                                    Distributor
                                  </Text>
                                </Box>
                              </Flex>
                            </Td>
                            <Td borderColor="gray.200">
                              <Badge
                                colorScheme="red"
                                variant="subtle"
                                px={3}
                                py={1}
                                borderRadius="full"
                                fontSize="sm"
                              ></Badge>
                            </Td>
                            <Td borderColor="gray.200">
                              <Button
                                size="sm"
                                colorScheme="red"
                                variant="outline"
                                leftIcon={<ViewIcon />}
                                onClick={() => {
                                  setSelectedDistributor(
                                    distributor.ManagerName
                                  );
                                  setIsOpenDist(true);
                                }}
                                _hover={{ bg: "red.50" }}
                              >
                                View Details
                              </Button>
                            </Td>
                          </Tr>
                        ))}
                    </Tbody>
                  </Table>
                </Box>

                {/* Pagination */}
                <Flex justify="space-between" align="center" mt={4} px={2}>
                  <Text fontSize="sm" color="gray.600">
                    Showing{" "}
                    {Math.min(
                      (distCurrentPage - 1) * distPageSize + 1,
                      filteredDistributors.length
                    )}{" "}
                    to{" "}
                    {Math.min(
                      distCurrentPage * distPageSize,
                      filteredDistributors.length
                    )}{" "}
                    of {filteredDistributors.length} distributors
                  </Text>

                  <HStack spacing={2}>
                    <Button
                      size="sm"
                      onClick={() =>
                        setDistCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      isDisabled={distCurrentPage === 1}
                      variant="outline"
                      leftIcon={<ChevronLeftIcon />}
                    >
                      Previous
                    </Button>

                    {Array.from(
                      {
                        length: Math.ceil(
                          filteredDistributors.length / distPageSize
                        ),
                      },
                      (_, i) => i + 1
                    )
                      .filter(
                        (page) =>
                          page === 1 ||
                          page === distCurrentPage ||
                          page === distCurrentPage - 1 ||
                          page === distCurrentPage + 1 ||
                          page ===
                          Math.ceil(
                            filteredDistributors.length / distPageSize
                          )
                      )
                      .map((page, index, array) => (
                        <React.Fragment key={page}>
                          {index > 0 && array[index - 1] !== page - 1 && (
                            <Text color="gray.400">...</Text>
                          )}
                          <Button
                            size="sm"
                            onClick={() => setDistCurrentPage(page)}
                            colorScheme={
                              distCurrentPage === page ? "red" : "gray"
                            }
                            variant={
                              distCurrentPage === page ? "solid" : "outline"
                            }
                            minW="40px"
                          >
                            {page}
                          </Button>
                        </React.Fragment>
                      ))}

                    <Button
                      size="sm"
                      onClick={() =>
                        setDistCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            Math.ceil(
                              filteredDistributors.length / distPageSize
                            )
                          )
                        )
                      }
                      isDisabled={
                        distCurrentPage ===
                        Math.ceil(
                          filteredDistributors.length / distPageSize
                        ) || filteredDistributors.length === 0
                      }
                      variant="outline"
                      rightIcon={<ChevronRightIcon />}
                    >
                      Next
                    </Button>
                  </HStack>
                </Flex>
              </Box>
            )}
          </Box>
        </Box>

        {/* Modal for Sales Officers Details */}
        <Modal
          isOpen={isOpenDist}
          isCentered
          motionPreset="slideInBottom"
          scrollBehavior="inside"
          blockScrollOnMount={false}
          onClose={() => {
            setIsOpenDist(false);
            setSelectedDistributor(null);
            setSalesOfficersDist([]);
            setDistributorDetails(null);
            setShowViewDetails(false);
            setSelectedSo(null);
          }}
          size="2xl"
        >
          <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
          <ModalContent
            maxH="90vh"
            maxW="70vw"
            bg="white"
            borderRadius="2xl"
            boxShadow="2xl"
            overflow="hidden"
          >
            <ModalHeader
              bgGradient="linear(to-r, red.600, red.500)"
              color="white"
              py={6}
              px={8}
              borderBottom="1px solid"
              borderColor="red.700"
            >
              {showViewDetails ? (
                <Flex align="center" gap={3}>
                  <Button
                    size="sm"
                    variant="ghost"
                    color="white"
                    leftIcon={<ChevronLeftIcon />}
                    onClick={() => {
                      setShowViewDetails(false);
                      setSelectedSo(null);
                    }}
                    _hover={{ bg: "red.700" }}
                  >
                    Back
                  </Button>
                  <Text>Store Details for {selectedSo?.soName}</Text>
                </Flex>
              ) : (
                ` Sales Officers for ${selectedDistributor}`
              )}

            </ModalHeader>
            <ModalCloseButton color="white" size="lg" variant="ghost" _hover={{ bg: "red.700" }} />
            <ModalBody p={6} bg="gray.50">
              {showViewDetails ? (
                <ViewDetails salesOfficer={selectedSo} fromDate={fromDate} toDate={toDate} />

              ) : (
                <>
                  {distributorDetails && (
                    <Box
                      mb={6}
                      p={4}
                      bg="white"
                      borderRadius="lg"
                      boxShadow="sm"
                      border="1px solid"
                      borderColor="gray.200"
                    >
                      <Heading size="md" mb={3} color="gray.800" fontWeight="bold">
                        Distributor Summary
                      </Heading>
                      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Total Shops
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="red.600">
                            {distributorDetails.totalShops || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Total Red Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="red.600">
                            {distributorDetails.totalRedScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Availability Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="green.600">
                            {distributorDetails.availabilityScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Activation Score
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="yellow.600">
                            {distributorDetails.activationScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Cooler
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="pink.600">
                            {distributorDetails.coolerScore || 0}
                          </Text>
                        </Box>
                        <Box
                          textAlign="center"
                          p={3}
                          bg="green.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="green.100"
                        >
                          <Text fontSize="sm" color="gray.600">
                            Cooler Bonus
                          </Text>
                          <Text fontSize="xl" fontWeight="bold" color="pink.600">
                            {distributorDetails.coolerBonus || 0}
                          </Text>
                        </Box>
                      </SimpleGrid>
                    </Box>
                  )}
                 <Box borderRadius="lg" boxShadow="md" border="1px solid" borderColor="gray.200" overflow="hidden">
                  <AgGridWrapper
                      rowData={salesOfficersDist}
                      columnDefs={salesOfficerColumns}
                      loading={loadingSODist}
                      height="350px"
                      rowHeight={52}
                      noRowsMessage="No sales officers found for this Distributor."
                      extraGridProps={{
                        context: { handleSOAction },
                        pagination: true,
                        paginationPageSize: gridPageSize,
                        suppressPaginationPanel: true,
                        suppressMovableColumns: true,
                        tooltipShowDelay: 300,
                        onGridReady: (params) => {
                          gridApiRef.current = params.api;
                          params.api.sizeColumnsToFit();
                        },
                        onFirstDataRendered: (params) => {
                          params.api.sizeColumnsToFit();
                        },
                        onGridSizeChanged: (params) => {
                          params.api.sizeColumnsToFit();
                        },
                      }}
                    />  
                    </Box>
                 

                  {/* Custom Pagination for AG Grid */}
                  {salesOfficersDist.length > 0 && (
                    <Flex justify="space-between" align="center" mt={4} px={2}>
                      <Text fontSize="sm" color="gray.600">
                        Showing {gridStartIndex} to {gridEndIndex} of {salesOfficersDist.length} sales officers
                      </Text>

                      <HStack spacing={2}>
                        <Button
                          size="sm"
                          onClick={handleGridPreviousPage}
                          isDisabled={gridCurrentPage === 1}
                          variant="outline"
                          leftIcon={<ChevronLeftIcon />}
                          colorScheme="red"
                        >
                          Previous
                        </Button>

                        {Array.from(
                          { length: totalGridPages },
                          (_, i) => i + 1
                        )
                          .filter(
                            (page) =>
                              page === 1 ||
                              page === gridCurrentPage ||
                              page === gridCurrentPage - 1 ||
                              page === gridCurrentPage + 1 ||
                              page === totalGridPages
                          )
                          .map((page, index, array) => (
                            <React.Fragment key={page}>
                              {index > 0 && array[index - 1] !== page - 1 && (
                                <Text color="gray.400">...</Text>
                              )}
                              <Button
                                size="sm"
                                onClick={() => handleGridPageChange(page)}
                                colorScheme={gridCurrentPage === page ? "red" : "gray"}
                                variant={gridCurrentPage === page ? "solid" : "outline"}
                                minW="40px"
                              >
                                {page}
                              </Button>
                            </React.Fragment>
                          ))}

                        <Button
                          size="sm"
                          onClick={handleGridNextPage}
                          isDisabled={gridCurrentPage === totalGridPages || salesOfficersDist.length === 0}
                          variant="outline"
                          rightIcon={<ChevronRightIcon />}
                          colorScheme="red"
                        >
                          Next
                        </Button>
                      </HStack>
                    </Flex>
                  )}
                </>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Container>
    </Box>
  );
}
export default MsdDp;